import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const AnalyticsIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33333 0.833374C1.53744 0.833401 1.73445 0.908337 1.88698 1.04397C2.03951 1.1796 2.13695 1.3665 2.16083 1.56921L2.16667 1.66671V12.5H14.6667C14.8791 12.5003 15.0834 12.5816 15.2378 12.7274C15.3923 12.8732 15.4852 13.0725 15.4976 13.2845C15.5101 13.4966 15.4411 13.7054 15.3048 13.8682C15.1685 14.0311 14.9751 14.1358 14.7642 14.1609L14.6667 14.1667H1.33333C1.12922 14.1667 0.932219 14.0917 0.77969 13.9561C0.627161 13.8205 0.529714 13.6336 0.505833 13.4309L0.5 13.3334V1.66671C0.5 1.44569 0.587797 1.23373 0.744078 1.07745C0.900358 0.921172 1.11232 0.833374 1.33333 0.833374ZM14.8283 3.18171C15.5783 3.18171 15.9533 4.08837 15.4233 4.61837L10.7817 9.26004C10.6098 9.43179 10.3767 9.52826 10.1338 9.52826C9.89077 9.52826 9.65772 9.43179 9.48583 9.26004L7.1875 6.96171L4.24167 9.90754C4.08541 10.0639 3.87344 10.1518 3.65238 10.1519C3.43132 10.152 3.21928 10.0642 3.06292 9.90796C2.90655 9.7517 2.81866 9.53973 2.81858 9.31867C2.8185 9.09761 2.90624 8.88557 3.0625 8.72921L6.53917 5.25254C6.62429 5.16738 6.72536 5.09981 6.83661 5.05372C6.94785 5.00763 7.06709 4.9839 7.1875 4.9839C7.30791 4.9839 7.42715 5.00763 7.53839 5.05372C7.64964 5.09981 7.75071 5.16738 7.83583 5.25254L10.1342 7.55087L12.8358 4.84837H12.4908C12.2698 4.84837 12.0579 4.76058 11.9016 4.6043C11.7453 4.44802 11.6575 4.23605 11.6575 4.01504C11.6575 3.79403 11.7453 3.58207 11.9016 3.42579C12.0579 3.2695 12.2698 3.18171 12.4908 3.18171H14.8283Z"
      fill={isActive ? 'url(#gradient)' : '#333333'}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0.5"
          y1="7.50004"
          x2="15.4578"
          y2="5.71204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default AnalyticsIcon;
